import React, { useState, useEffect } from 'react';
import { Popover, Col, Divider, Button, Input, Switch } from 'antd';
import { Link2Icon, UnLinkIcon } from 'components/Icons';
import { isValidUrlFormat } from 'utils/hyperlink';

function LinkEditorPopover({
  visible,
  handleLinkPopoverOpen,
  imageId,
  updateLink,
  link,
  globalLink,
}) {
  const consolidatedLink = link || globalLink;
  const isEdit = !!consolidatedLink;

  const [linkForAllImages, setLinkForAllImages] = useState(false);
  const [linkValue, setLinkValue] = useState('');
  const [isLinkValid, setIsLinkValid] = useState(false);

  // 1. if globalLink && linkForAllImages = true, show unlink button
  // 2. if individul link && linkForAllImages === false
  const showUnlink =
    (globalLink && linkForAllImages === true) || (link && linkForAllImages === false);

  useEffect(() => {
    setLinkValue(consolidatedLink);
  }, [consolidatedLink]);

  const checkIsLinkValid = (value) => {
    return (isEdit && value === '') || isValidUrlFormat(value);
  };

  const onChange = (checked) => {
    setLinkForAllImages(checked);
    if (checked) {
      setIsLinkValid(checkIsLinkValid(linkValue));
    }
  };

  const onChangeLinkValue = (e) => {
    const value = e.target.value.trim();
    setLinkValue(value);
    // for edit allow to save '' , this will remove the link
    setIsLinkValid(checkIsLinkValid(value));
  };

  const onUpdateLink = (link = '') => {
    // add link to all images OR current image
    updateLink(link, linkForAllImages ? 'all' : imageId);
    handleLinkPopoverOpen(false);
  };

  const onSave = () => {
    onUpdateLink(linkValue);
  };

  const onUnlink = () => {
    onUpdateLink('');
  };

  const content = (
    <Col className="content">
      <div className="title">
        <h3 className="ant-popover-title">{isEdit ? 'Edit' : 'Add'} link</h3>
        <Divider />
      </div>
      <div className="body">
        <label>Link URL</label>
        <Input
          placeholder="Paste link here"
          value={linkValue}
          onChange={onChangeLinkValue}
          type="url"
          maxLength={1000}
        />
      </div>
      <div className="footer">
        <div className="switch-wrapper">
          <Switch checked={linkForAllImages} onChange={onChange} />
          Push link to all images
        </div>

        <div className="button-wrapper">
          {isEdit && showUnlink && (
            <>
              <Button
                className="medium-btn transparent-btn"
                icon={<UnLinkIcon />}
                onClick={onUnlink}>
                Unlink
              </Button>
              <Divider type="vertical" />
            </>
          )}

          <Button className="medium-btn grey-btn" onClick={() => handleLinkPopoverOpen(false)}>
            Cancel
          </Button>
          <Button className="medium-btn secondary-btn" onClick={onSave} disabled={!isLinkValid}>
            Save
          </Button>
        </div>
      </div>
    </Col>
  );

  return (
    <Popover
      content={content}
      placement="bottom"
      overlayClassName={`link-editor-popover Prosprich-editor-components-popover ${
        isEdit ? 'edit' : ''
      }`}
      trigger="click"
      visible={visible}
      onVisibleChange={handleLinkPopoverOpen}>
      <Link2Icon className="link-icon" />
    </Popover>
  );
}

export default LinkEditorPopover;
